<template>
  <b-card class="mx-2" no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="text-capitalize">{{ $t("table.show") }}</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
              :value="perPage"
              @input="$emit('per-page', $event)"
            />
            <label class="text-capitalize">{{ $t("table.entries") }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="modelSearchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('table.search')"
              />
              <button class="btn btn-success" @click="$emit('refresh-data')">
                <feather-icon icon="RefreshCwIcon" size="14" />
              </button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('no_record_found')"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #head(panel_name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(description)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(device_type)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(device_id)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(device_name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(area_name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(area_id)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(event_type)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(user_name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(user_id)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(panel.name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(event_created_at)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(id_alarm)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted text-capitalize">{{
              $t("table.showing", {
                from: dataMeta.from,
                to: dataMeta.to,
                of: dataMeta.of,
              })
            }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <Pagination
              :totalList="totalList"
              :currentPage="currentPage"
              @updatePagination="(val) => $emit('update', val)"
              :perPage="perPage"
            >
            </Pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import vSelect from "vue-select";
import { BBadge } from "bootstrap-vue";
import { computed } from "@vue/composition-api";

export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    dataMeta: {
      type: Object,
      required: true
    },
    fetchList: {
      type: Function,
      required: true
    },
    isSortDirDesc: {
      type: Boolean,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    perPageOptions: {
      type: Array,
      required: true
    },
    searchQuery: {
      type: String,
      required: true
    },
    sortBy: {
      type: String,
      required: true
    },
    tableColumns:{
      type: Array,
      required: true
    },
    totalList: {
      type: Number,
      required: true
    }
  },
  components: {
    Pagination,
    vSelect,
    BBadge
  },
  setup (props, { emit }) {

    const modelSearchQuery = computed({
      get: () => props.searchQuery,
      set: (val) => emit('update:searchQuery', val)
    })

    return { modelSearchQuery }
  }
}
</script>
